import React from 'react'
import Liberyus from '../../components/general/liberyus'
import { useTranslation } from 'react-i18next'
import HomeBanner from './home-banner';
import PoweredBy from './powered-by';
import References from './references';
import Explore from './explore';
import VideoBanner from './video-banner';
import HomeNews from './home-news';
import HomeOurTeam from './home-our-team';
import HomeLibecms from './home-libecms';
import HomeAbout from './home-about';

const HomePage = () => {
    const { t } = useTranslation()

    return (
        <Liberyus>
            <div className='home-page'>
                <HomeBanner />
                <PoweredBy />
                <References />
                <Explore viewBg />
                <VideoBanner />
                {/* <HomeNews isBlog={false} /> */}
                <HomeOurTeam />
                <HomeLibecms />
                <HomeAbout />
            </div>
        </Liberyus>
    )
}

export default HomePage
